import React, { Component, useEffect, useState } from "react";
import { Row, Tab, Tabs } from "react-bootstrap";
import {
  FormGroup,
  ModalFooter,
  FormWrapper,
  FormColumn,
  Button,
  FormControl,
  SeachForm,
  Alert,
  ButtonCommonTheme,
  Tip
} from "modules/theme";
// import { TabItemsCallStyle } from '../styles/dialpadstyle';
import { InsightTitleInfo, ListData, ListImage, ListName, ProfileInfo } from "../styles/main";
import { Editor } from "react-draft-wysiwyg";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  chatSelector,
  globalStateSelector,
} from "../../../../../store/selector";
import {
  callAction,
  chatAction,
  messageAction,
} from "../../../../../store/action";
import "./ContactRightPartTheme.css";
import APIManager from "modules/common/apiManager";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { capitalize } from "../../../../common/utils";
import { getUUID } from "../../../../screens/chatscreen/utils";
import { localStore } from "../../../../../helpers";
import { changeLastAssistMessage } from "../../../../../dialpad/service/chat.service";
import MessageRenderer from "../../../../screens/chatscreen/components/MessageRenderer/MessageRenderer";
import { useRef } from "react";
import { useChatScrollHandler } from "../../../../screens/chatscreen/components/MessageScreenBody/useChatScrollHandler";
import AssistRenderer from "../../../../screens/chatscreen/components/AssistRenderer/AssistRenderer";

// const TabItemsStyle = styled.div`
//   width: 100%;
//   .tabItemStyle {
//     display: flex;
//     align-items: flex-end;
//     height: 52px;
//     padding: 0px 20px;
//     border-bottom: 1px solid rgb(226, 232, 239);
//   }

//   .tabItemStyle > div {
//     width: 100%;
//     // height: calc(100% - 8px);
//     display: flex;
//     -webkit-box-align: center;
//     align-items: center;
//     position: relative;
//     flex-flow: row-reverse wrap;
//     -webkit-box-pack: start;
//     justify-content: flex-start;
//   }

//   .tabItemStyle > div > ul {
//     display: flex;
//     flex-direction: row;
//     -webkit-box-pack: start;
//     justify-content: flex-start;
//     -webkit-box-align: center;
//     align-items: center;
//     flex: 1 1 0%;
//     border: none;
//   }

//   ul > li > a {
//     position: relative;
//     padding: 3px 8px 12px;
//     font-size: 14px;
//     cursor: pointer;
//     color: rgb(100, 116, 145);
//     border: none !important;
//     font-weight: 600;
//     background: #fff;
//     // border-bottom: 3px solid #fff !important;
//   }

//   ul > li.active > a,
//   ul > li.active > a:focus,
//   ul > li.active > a:hover {
//     color: rgb(8, 15, 26) !important;
//     border-bottom: 3px solid rgb(5, 102, 255) !important;
//     background: #fff !important;
//     font-weight: 600 !important;
//   }

//   li > a:hover {
//     background: #fff !important;
//   }
//   // ul > li > a:hover {
//   //   color: rgb(8, 15, 26);
//   //   border-bottom: 1px solid rgb(5, 102, 255);
//   // }
// `;

const TabItemsStyle = styled.div`
  height: 100%;
  width: 100%;
  .tabItemStyle {
    display: flex;
    // align-items: flex-end;
    // height: 52px;
    // padding: 0px 20px;
    // border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tab-content,
  .tab-pane {
    height: 100%;
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    // display: flex;
    // -webkit-box-align: center;
    // align-items: center;
    // position: relative;
    // flex-flow: row-reverse wrap;
    // -webkit-box-pack: start;
    // justify-content: flex-start;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
    border-bottom: 1px solid rgb(226, 232, 239);
    padding: 14px 20px 0px 20px;
  }

  ul > li > a {
    position: relative;
    padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    border: none !important;
    font-weight: 600;
    background: #fff;
    // border-bottom: 3px solid #fff !important;
  }

  ul > li.active > a,
  ul > li.active > a:focus,
  ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  li > a:hover {
    background: #fff !important;
  }
  // ul > li > a:hover {
  //   color: rgb(8, 15, 26);
  //   border-bottom: 1px solid rgb(5, 102, 255);
  // }

  @media (max-width: 639px) {
    .tabItemStyle > div > ul {
      padding: 22px 20px 0px 100px;
    }
  }

   .details-table,
  .long-value-table {
    width: 100%;
    border-collapse: collapse;
    // margin-bottom: 20px; /* Spacing between tables */
  }

  .details-table td,
  .long-value-table td {
    padding: 5px 3px 2px 0px ;
    border: none;
  }

  .details-table .detail-key {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #858585;
  }

  .details-table .detail-value {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #000000;
    overflow: hidden;
    text-overflow: ellipsis;
    /* word-break: break-all; */
    max-width: 200px;
    white-space: nowrap;
  }
`;
const BackButton = styled.button`
  position: absolute;
  top: 7px;
  left: 56px;
  z-index: 10;
  outline: none;
  border: none;
  background: none;
  padding: 10px;
  border-radius: 50%;
  background-color: #f8f9fa;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    display: none;
  }
`;

const AccordionSection = styled.div`
  .accordion {
    // border: 1.5px solid #e6eaef;
    border-radius: 8px;
    border: none !important;
  }
  .accordionContainer {
    // border-bottom: 1.5px solid #e6eaef;
    background: #f4f8ff;
    border-radius: 8px;
    padding: 10px 10px;
  }
  .header {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
  }
  .title {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #000000;
    margin-right: 25px;
  }
  .arrow {
    font-size: 22px;
    // margin-left: 30px;
    color: #1c1b1f;
  }
  .content {
    padding: 0px 6px;
    // font-size: 12px;
    // font-weight: 400;
    // letter-spacing: 0.03em;
    // color: #000;
    // margin: 0;
  }

  .section {
  margin: 15px 0px 0px 0px;
  padding: 0px 6px;
}

.section-header {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
  color: #272728;
  letter-spacing: 0.03em;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-checked {
  color: #4CB944;
  font-size: 16px !important;
  font-variation-settings: 'FILL' 1, 'wght' 700, 'GRAD' 0, 'opsz' 48;
}

.section-unchecked {
  color: #D95461;
  font-size: 16px !important;
  font-variation-settings: 'FILL' 1, 'wght' 700, 'GRAD' 0, 'opsz' 48;
}

.count {
  font-size: 12px;
  color: #B1B1B1;
  padding-left: 5px;
}

.topics-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.topic {
  display: flex;
  // justify-content: space-between;
  align-items: center;
}

.topic span {
  font-size: 14px;
font-weight: 600;
line-height: 25px;
letter-spacing: 0.03em;
}

.checked {
  color: #4CB944;
  text-decoration: line-through;
}

.unchecked {
  color: #D95461;
}

.status-icon {
  font-size: 12px;
  margin-right: 8px;
}
`;

const TypingIndicatorBubble = ({ name }) => (
  // <div className="typing-indicator-bubble">
  //   <div className="typing-dot"></div>
  //   <div className="typing-dot"></div>
  //   <div className="typing-dot"></div>
  // </div>
  <div id="typing" className="ticontainer">
    <div className="tiblock">
      <div className="tidot"></div>
      <div className="tidot"></div>
      <div className="tidot"></div>
    </div>
  </div>
);


const getRole = (message) => {
  if (message.from) return message.from;
  return "customer";
};

const ContactRightPartTheme = ({ dynamicUpdate, ...props }) => {
  // renderData(title, value) {
  //   return (
  //     <div className="info">
  //       <h6 className="title">{title}</h6>
  //       <h6 className="value">{value}</h6>
  //     </div>
  //   );
  // }
  // const { configProcessor, selectedAssignedList, showCustomerInfo } = props;

  const mAPI = new APIManager();

  const [loading, setLoading] = useState(false);

  const [prompt, setPrompt] = useState("");

  const [isOpen, setIsOpen] = useState([0, 1]);

  const [isAccordionOpenChecklist, setIsAccordionOpenChecklist] = useState(true);

  const chatContainerRef = useRef(null);
  const scrollPositions = useRef({});

  // Function to scroll to the bottom
  const scrollToBottom = () => {
    const chatContainer = document.querySelector(".chat-container");
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  // Effect to scroll to the bottom when agentAssist updates
  useEffect(() => {
    scrollToBottom();
  }, [props.chatAgentAssist]);
  // const [suggestionsList, setSuggestionsList] = useState([]);

  const resetAllData = () => {
    setPrompt("");
  };

  const getConversationId = () => {
    const answer = props.chatAgentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const conversationData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.conversationId
      );

      return conversationData
        ? conversationData &&
        conversationData.meta &&
        conversationData.meta.conversationId
        : "";
    }

    return "";
  };

  const getSessionId = () => {
    const answer = props.chatAgentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const sessionData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.sessionId
      );

      return sessionData
        ? sessionData && sessionData.meta && sessionData.meta.sessionId
        : "";
    }

    return "";
  };

  const saveData = (e) => {
    e.preventDefault();
    let _this = this;
    resetAllData();

    setLoading(true);

    if (!prompt || prompt.trim() === "") {
      setLoading(false);
      return Alert.error("Enter Data");
    }

    let suggestion = prompt || "";
    suggestion = suggestion.trim();
    props.setChatAgentAssist(
      { key: "Question", value: suggestion },
      props.selectedAssignedList.identifier
    );

    const conversationId = getConversationId();
    const sessionId = getSessionId();
    // let tData = {
    //   suggestion: suggestion,
    // };
    mAPI.sendPostAPI(
      `/agent-response`,
      {
        teamId: props.selectedAssignedList.teamId,
        meta: {
          conversationId: conversationId || "",
          sessionId: sessionId || "",
        },
        slots: [],
        prompt: suggestion,
      },
      (data) => {
        if (data) {
          resetAllData();
          // suggestionsList = data;
          props.setChatAgentAssist(
            { key: "Answer", value: data },
            props.selectedAssignedList.identifier
          );
          // dispatch(
          //   chatAction.dynamicUpdate({
          //     data: { key: "agentAssist", value: data },
          //   })
          // );
          // Alert.success(`${data.message}`);
        } else {
          let message =
            data && data.message ? data.message : "Something wrong happened";
          props.setChatAgentAssist(
            {
              key: "Answer",
              value: [
                {
                  type: "text",
                  content: message,
                  method: "error",
                },
              ],
            },
            props.selectedAssignedList.identifier
          );
          Alert.error(message);
          // Alert.error("Something went wrong");
          // Alert.success(`Successfully Added`);
        }
        setLoading(false);
      },

      (errorCode, data) => {
        setLoading(false);
        if (errorCode === 201) {
          // Alert.success(`${data.message}`);
          let message =
            data && data.message ? data.message : "Successfully Done";
          Alert.success(`${message}`);
          resetAllData();
        } else {
          // Alert.error(`${data.message}`);
          let message =
            data && data.message ? data.message : "Something wrong happened";
          props.setChatAgentAssist(
            {
              key: "Answer",
              value: [
                {
                  type: "text",
                  content: message,
                  method: "error",
                },
              ],
            },
            props.selectedAssignedList.identifier
          );
          Alert.error(message);
          // Alert.error(message);
        }
        // this.apiResponse(errorCode, data);
      }
    );
  };

  const currentIdentifier = props.selectedAssignedList.identifier || "";

  const filteredEntries = props.chatAgentAssist.filter(
    (item) => item.identifier === currentIdentifier
  );
  // Group filtered entries by identifier
  const groupedEntries = filteredEntries.reduce((acc, item) => {
    if (!acc[item.identifier]) {
      acc[item.identifier] = [];
    }
    acc[item.identifier].push(item);
    return acc;
  }, {});

  // Convert groupedEntries to an array for rendering
  const groupedEntriesArray = Object.values(groupedEntries);

  // const clearChat = () => {
  //   props.clearChatAgentAssist(); // Clear the agentAssist using Redux
  // };

  const renderTitle = (title) => {
    return (
      <InsightTitleInfo className=''>{title}</InsightTitleInfo>
    );
  }

  const toTitleCaseWithSpaces = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
      .replace(/(^|\s)\S/g, (group) => group.toUpperCase()); // Capitalize the first letter of each word
  };

  const toggleAccordion = (index) => {
    setIsOpen((prevIsOpen) => {
      return prevIsOpen.includes(index)
        ? prevIsOpen.filter((i) => i !== index) // Close if already open
        : [...prevIsOpen, index]; // Open if closed
    });
  };

  const toggleAccordionChecklist = () => {
    setIsAccordionOpenChecklist(!isAccordionOpenChecklist);
  }


  const renderAccordion = (title, index, details) => {
    // Check if there are any valid details (non-empty, non-null, non-undefined)
    const hasValidDetails = details.some(({ value }) => value !== undefined && value !== null && value !== "");

    // Do not render the accordion if there are no valid details
    if (!hasValidDetails) {
      return null; // Return nothing if no valid details
    }

    const isAccordionOpen = isOpen.includes(index); // Check if this index is open

    return (
      <div className="accordion" key={index}>
        <div className="accordionContainer">
          <div className="header" onClick={() => toggleAccordion(index)}>
            <span className="title">{title}</span>
            <span className="material-symbols-outlined arrow">
              {isAccordionOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            </span>
          </div>
        </div>
        {isAccordionOpen && (
          <div className="content">
            <table className="details-table" style={{ width: "100%", marginTop: "10px" }}>
              <tbody>
                {details.map(({ key, value }, idx) => (
                  value !== undefined && value !== null && value !== "" && ( // Skip if value is blank
                    <tr key={idx}>
                      <td className="long-value-row detail-key" style={{ width: '75px' }}>
                        {toTitleCaseWithSpaces(key)}:
                      </td>
                      <td className="detail-value pl-3" style={{ wordBreak: 'break-all' }}>{value}</td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // const handleInputChange = (e) => {
  //   const { configProcessor } = props;
  //   const value = e.target.value;
  //   setMessage(value);
  //   dynamicUpdate({
  //     data: { key: `agentAssistReply_${props.selectedAssignedList.sessionId}`, value: value },
  //   });
  // };

  // const sendMessage = (e, type) => {
  //   const { configProcessor, assistMessageList, currentUser } = props;

  //   e.preventDefault();
  //   if (props.agentAssistReply.trim().length === 0) {
  //     return;
  //   }

  //   const messagePayload = {
  //     from: "customer",
  //     timeStamp: new Date().toISOString(),
  //     type: 'text',
  //     plateform: "agent-assist",
  //     content: {
  //       text: message,
  //     },
  //     id: getUUID(),
  //   };
  //   const messageData = {
  //     userId: currentUser.userId,
  //     timeStamp: new Date().toISOString(),
  //     agent: {
  //       email: currentUser.email,
  //       name: currentUser.name,
  //       role: currentUser.role,
  //       userId: currentUser.userId,
  //       username: currentUser.user_name,
  //     },
  //     message: messagePayload,
  //   };
  //   setMessage("");
  //   dynamicUpdate({
  //     data: { key: `agentAssistReply_${props.selectedAssignedList.sessionId}`, value: "" },
  //   });
  //   configProcessor("sendPayload", {
  //     ...props.selectedAssignedList,
  //     payloadType: 'message',
  //     "rmq:pattern": "agent:assist:message",
  //     id: messagePayload.id,
  //     message: {
  //       ...(props.selectedAssignedList && props.selectedAssignedList.message),
  //       ...messagePayload,
  //     },
  //   });


  //   dynamicUpdate({
  //     data: {
  //       key: `assistMessageList.${selectedAssignedList.identifier}`,
  //       value: [
  //         messageData,
  //         ...(assistMessageList[selectedAssignedList.identifier] || []),
  //       ],
  //     },
  //   });
  // };

  const handleInputChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    dynamicUpdate({
      data: {
        key: `agentAssistReply_${props.selectedAssignedList.sessionId}`,
        value,
      },
    });
  };

  const sendMessage = (e) => {
    e.preventDefault();

    const {
      configProcessor,
      assistMessages,
      currentUser,
      selectedAssignedList,
      agentAssistReply,
    } = props;

    const text = agentAssistReply && agentAssistReply.trim();
    if (!text) return;

    const messagePayload = {
      from: "customer",
      timeStamp: new Date().toISOString(),
      type: 'text',
      plateform: "agent-assist",
      content: {
        text,
      },
      id: getUUID(),
    };

    const messageData = {
      userId: currentUser.userId,
      timeStamp: new Date().toISOString(),
      agent: {
        email: currentUser.email,
        name: currentUser.name,
        role: currentUser.role,
        userId: currentUser.userId,
        username: currentUser.user_name,
      },
      message: messagePayload,
    };

    dynamicUpdate({
      data: {
        key: `agentAssistReply_${selectedAssignedList.sessionId}`,
        value: "",
      },
    });

    configProcessor("sendPayload", {
      tenantId: localStore.getItem('selected-tenant'),
      customerIdentifier: props.selectedAssignedList && props.selectedAssignedList.identifier,
      customerSessionId: props.selectedAssignedList && props.selectedAssignedList.sessionId,
      teamId: props.selectedAssignedList.teamId,
      teamName: props.selectedAssignedList.teamName,
      identifier: `AGENT-ASSIST-SESSION:${currentUser.userId}:${props.selectedAssignedList && props.selectedAssignedList.sessionId}`,
      payloadType: 'message',
      "rmq:pattern": "agent:assist:message",
      id: messagePayload.id,
      message: {
        ...(selectedAssignedList && selectedAssignedList.message || {}),
        ...messagePayload,
      },
    });

    changeLastAssistMessage({
      list: assistMessages, // ✅ correct list
      identifier: selectedAssignedList.identifier,
      receivedMessage: messagePayload,
      key: "assistMessageList", // ✅ correct key
    });

    const identifier = `AGENT-ASSIST-SESSION:${currentUser.userId}:${props.selectedAssignedList && props.selectedAssignedList.sessionId}`;
    dynamicUpdate({
      data: {
        key: `assistMessageList.${identifier}`,
        value: [
          messageData,
          ...(assistMessages || []),
        ],
      },
    });
  };


  const startOnClick = (e) => {
    e.preventDefault();
    const { configProcessor, messageList, assignedList, currentUser } = props;
    // const messageToSend = {
    //   id: getUUID(),
    //   eventMessage: {
    //     from: "customer",
    //     type: "startSession",
    //   },
    //   timeStamp: new Date().toISOString(),
    //   plateform: "agent-assist",
    // };
    configProcessor("sendPayload", {
      // ...props.selectedAssignedList,
      agent: {
        email: currentUser.email,
        name: currentUser.name,
        role: currentUser.role,
        userId: currentUser.userId,
        username: currentUser.user_name,
      },
      tenantId: localStore.getItem('selected-tenant'),
      customerIdentifier: props.selectedAssignedList && props.selectedAssignedList.identifier,
      customerSessionId: props.selectedAssignedList && props.selectedAssignedList.sessionId,
      teamId: props.selectedAssignedList.teamId,
      teamName: props.selectedAssignedList.teamName,
      identifier: `AGENT-ASSIST-SESSION:${currentUser.userId}:${props.selectedAssignedList && props.selectedAssignedList.sessionId}`,
      payloadType: 'event',
      plateform: "agent-assist",
      "rmq:pattern": "agent:assist:event",
      eventMessage: {
        from: "customer",
        type: "startSession",
      },
    });
  }

  const agentAssistHistory = () => {
    // e.preventDefault();
    const {
      configProcessor,
      currentUser,
    } = props;

    configProcessor("getAssistHistory", {
      identifier: `AGENT-ASSIST-SESSION:${currentUser.userId}:${props.selectedAssignedList && props.selectedAssignedList.sessionId}`,
    });
  }

  // useEffect(() => {
  //   const selectedAssignedList = props.selectedAssignedList
  //   return () => {
  //     if (chatContainerRef.current && selectedAssignedList && selectedAssignedList.sessionId) {
  //       scrollPositions.current[selectedAssignedList.sessionId] = chatContainerRef.current.scrollTop;
  //     }
  //   };
  // }, [props.selectedAssignedList]);

  // useEffect(() => {
  //   const selectedAssignedList = props.selectedAssignedList
  //   if (chatContainerRef.current && selectedAssignedList && selectedAssignedList.sessionId) {
  //     const savedPosition = scrollPositions.current[selectedAssignedList.sessionId];
  //     if (savedPosition !== undefined) {
  //       chatContainerRef.current.scrollTop = savedPosition;
  //     } else {
  //       // If no previous scroll position, scroll to bottom
  //       chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
  //     }
  //   }
  // }, [props.selectedAssignedList]);

  // // Auto-scroll when new messages arrive
  // useEffect(() => {
  //   if (!chatContainerRef.current) return;

  //   const chatContainer = chatContainerRef.current;

  //   // Check if user is near the bottom before updating
  //   const isAtBottom =
  //     chatContainer.scrollHeight - chatContainer.scrollTop <= chatContainer.clientHeight + 100;

  //   if (isAtBottom || props.assistMessages.length === 1) {
  //     chatContainer.scrollTop = chatContainer.scrollHeight;
  //   }
  // }, [props.assistMessages]);


  // const handleScrollToTop = () => {
  //   const identifier = `AGENT-ASSIST-SESSION:${props.currentUser.userId}:${props.selectedAssignedList && props.selectedAssignedList.sessionId}`;
  //   const currentPaginationInfo =
  //     props.assistPaginationInfo[identifier];

  //   if (!currentPaginationInfo) {
  //     console.error(`Pagination info not found for identifier: ${identifier}`);
  //     return;
  //   }
  //   const { page_no, count } = currentPaginationInfo;
  //   if (count - 20 * page_no > 0) {
  //     dynamicUpdate({
  //       data: {
  //         key: `assistPaginationInfo.${identifier}`,
  //         value: {
  //           ...(props.assistPaginationInfo[identifier] || {}),
  //           page_no: page_no + 1,
  //         },
  //       },
  //     });
  //     // fetch more messages
  //     const msgs = props.assistMessages[identifier];
  //     // configProcessor("getHistory", {
  //     //   identifier: selectedAssignedList.identifier,
  //     //   page_no: page_no + 1,
  //     //   timestamp: msgs[msgs.length - 1].timeStamp,
  //     // });
  //     if (msgs && msgs.length > 0) {
  //       props.configProcessor("getAssistHistory", {
  //         identifier: identifier,
  //         page_no: page_no + 1,
  //         timestamp: msgs[msgs.length - 1] && msgs[msgs.length - 1].message && msgs[msgs.length - 1].message.timeStamp,
  //         sessionId: props.selectedAssignedList && props.selectedAssignedList.sessionId || "",
  //       });
  //     } else {
  //       console.error("Message list is empty or undefined for the selected identifier.");
  //     }
  //   }
  // };
  // const [heightFromBottom, setHeightFromBottom] = useChatScrollHandler(
  //   chatContainerRef,
  //   handleScrollToTop,
  //   `AGENT-ASSIST-SESSION:${props.currentUser.userId}:${props.selectedAssignedList && props.selectedAssignedList.sessionId}`
  // );


  return (
    <div className="right-part__left" style={{ background: "#fff" }}>
      <BackButton
        onClick={() =>
          dynamicUpdate({ data: { key: "showCustomerInfo", value: false } })
        }
      >
        <span className="material-symbols-outlined">arrow_back</span>
      </BackButton>
      {/* <ProfileInfo>
      <ListData className='rightPart'>
        <div className='d-flex align-items-center'>
          <ListImage>
            <img src='/images/LoginAgent.png' />
          </ListImage>
          <ListName>
            <h6>ANNA DUNCAN</h6>
          </ListName>
        </div>
        <div className='actions'>
          <span class="material-symbols-outlined">
            edit
          </span>
        </div>
      </ListData>
      <div className='infoData mt-5'>
        {this.renderData(
          'Email',
          'ananananan@gmail.com'
        )}
        {this.renderData(
          'Phone Number',
          '+91 908 097 7000'
        )}
        {this.renderData(
          'City',
          'Ahmedabad'
        )}
        {this.renderData(
          'Website',
          'www.annaduncan.com'
        )}
      </div>
    </ProfileInfo> */}
      <TabItemsStyle>
        {/* <button
          className="rounded-circle ratio-1x1 bg-body-secondary p-3 conversation-header__back_button flex align-items-center justify-content-center"
          style={{
            outline: "none",
            // border: "1px solid #d3d3d3",
            border: "none",
          }}
          onClick={(_) => {

            dynamicUpdate({ data: { key: "showCustomerInfo", value: false } });
          }}
        >
          <span className="material-symbols-outlined">arrow_back</span>
        </button> */}
        <div className="tabItemStyle h-100">
          <Tabs
            className="liveMonitorTabs"
            // onSelect={(eventKey) => this.handleReset(eventKey)}
            // // style={{ marginTop: "15px", marginLeft: "15px" }}
            // defaultActiveKey={activeTab}
            activeKey={props.activeTabRight}
            id="uncontrolled-tab-example"
            defaultActiveKey="info"
            onSelect={(k) => {
              // if (!smartAssistant || k === "smartAssistant") {
              props.setActiveTabRight(k); // Update activeTab in parent
              // }
              if (k === "agentAssistant") {
                agentAssistHistory();
              }
            }}
          >
            <Tab eventKey="info" title="Info">
              <div style={{ height: 'calc(100vh - 100px)', overflowY: 'auto' }}>
                <Row
                  style={{
                    padding: '18px 28px',
                    // background: colors.colorWhite,
                    // borderRadius: '20px'
                  }}
                >
                  {renderTitle('Details')}
                  <table className="details-table" style={{ width: "auto", marginTop: '10px' }}>
                    <tbody>
                      {props.selectedAssignedList && props.selectedAssignedList.customer && typeof props.selectedAssignedList.customer === "object"
                        ? Object.entries(props.selectedAssignedList.customer)
                          .filter(([_, value]) => value !== undefined && value !== null && value !== "")
                          .map(([key, value]) => (
                            <tr key={key}>
                              <td className="long-value-row detail-key" style={{ width: '75px' }}>{toTitleCaseWithSpaces(key)}: </td>
                              <Tip text={value}><td className="detail-value pl-3">{value}</td></Tip>
                            </tr>
                          )) : ""}
                    </tbody>
                  </table>

                  {/* {data && data.map((detail) => this.renderStatus(detail))} */}
                </Row>
                {props.chatChecklist && Array.isArray(props.chatChecklist) && props.chatChecklist.length !== 0 ?
                  <span>
                    <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
                    <Row
                      style={{
                        padding: '10px 12px',
                      }}
                    >
                      <AccordionSection>
                        <div className="accordionContainer">
                          <div className="header" onClick={() => toggleAccordionChecklist()}>
                            <span className="title">AI Checklist</span>
                            <span className="material-symbols-outlined arrow">
                              {isAccordionOpenChecklist ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                            </span>
                          </div>
                        </div>
                        {isAccordionOpenChecklist && props.chatChecklist && Array.isArray(props.chatChecklist) && props.chatChecklist.map((section, sectionIndex) => (
                          <div key={sectionIndex} className="section">
                            <div className="section-header">
                              <div className="">
                                <span>{section.name}</span>
                                <span className="count">
                                  ({section.topics.filter((topic) => topic.checked).length}/
                                  {section.topics.length})
                                </span>
                              </div>
                              {section.topics.filter((topic) => topic.checked).length === section.topics.length && (
                                <span class="material-symbols-outlined section-checked">
                                  check_circle
                                </span>
                              )}
                            </div>
                            <ul className="topics-list">
                              {section.topics.map((topic, topicIndex) => (
                                <li key={topicIndex} className={`topic ${topic.checked ? 'checked' : 'unchecked'}`}>
                                  {/* <span className={`status-icon ${topic.checked ? 'checked' : 'unchecked'}`}> */}
                                  {topic.checked ? <span class="material-symbols-outlined section-checked pr-3">
                                    check_circle
                                  </span> : <span class="material-symbols-outlined section-unchecked pr-3">
                                    info
                                  </span>}
                                  {/* </span> */}
                                  <span>{topic.topic}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </AccordionSection>
                    </Row>
                  </span>
                  : ""}
                <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
                <Row
                  style={{
                    padding: '10px 12px',
                  }}
                >
                  <AccordionSection>
                    {renderAccordion(
                      "Team",
                      0,
                      [
                        { key: "Name", value: props.selectedAssignedList && props.selectedAssignedList.teamName ? props.selectedAssignedList.teamName : "" }
                      ]
                    )}
                    {renderAccordion(
                      "Platform",
                      1,
                      [
                        { key: "Name", value: props.selectedAssignedList && props.selectedAssignedList.provider && props.selectedAssignedList.provider.name ? props.selectedAssignedList.provider.name : "" },
                        { key: "Type", value: props.selectedAssignedList && props.selectedAssignedList.plateform ? capitalize(props.selectedAssignedList.plateform) : "" }
                      ]
                    )}
                    {renderAccordion(
                      "Campaign",
                      1,
                      [
                        { key: "Name", value: props.selectedAssignedList && props.selectedAssignedList.campaign && props.selectedAssignedList.campaign.name ? props.selectedAssignedList.campaign.name : "" },
                      ]
                    )}
                  </AccordionSection>
                  {/* {renderTitle('customer Info:')}
                <table className="details-table" style={{ width: "auto", marginTop: '10px' }}>
                  <tbody>
                    {props.selectedAssignedList && props.selectedAssignedList.customer && typeof props.selectedAssignedList.customer === "object"
                      ? Object.entries(props.selectedAssignedList.customer).map(([key, value]) => (
                        <tr key={key}>
                          <td className="long-value-row detail-key">{toTitleCaseWithSpaces(key)}: </td>
                          <td className="detail-value pl-3">{value}</td>
                        </tr>
                      )) : ""}
                  </tbody>
                </table> */}
                </Row>
              </div>
            </Tab>
            {/* <Tab eventKey="smartAssistant" title="Smart Assistants">
              <ul className="suggestionBox chat-container">
                {groupedEntriesArray.length > 0 &&
                  groupedEntriesArray.map((group, index) => (
                    <div key={index} className="chat-group">
                      {group.map((item, subIndex) => {
                        return (
                          <div
                            key={subIndex}
                            className={`chat-row ${item.key === "Question" ? "question" : "answer"
                              }`}
                          >
                            {item.key === "Question" && (
                              <li className="chat-bubble question-bubble" style={{ padding: '10px' }}>
                                {item.value}
                                <div className="message-info-td">
                                  <span
                                    className="material-symbols-outlined message-copy"
                                    onClick={() => {
                                      if (item.value) {
                                        navigator.clipboard.writeText(item.value);
                                        Alert.success(
                                          "Message copied successfully"
                                        );
                                      } else {
                                        Alert.error("Message not copied");
                                      }
                                    }}
                                  >
                                    content_copy
                                  </span>
                                </div>
                              </li>
                            )}
                            {item.key === "Answer" && (
                              <div className="chat-bubble answer-bubble">
                                {Array.isArray(item.value)
                                  ? item.value.map((answer, idx) => (
                                    // <div key={idx}>
                                    answer.method !== "error" ?
                                      <li
                                        key={idx}
                                        // className={`${answer.method === "error" ? "error" : ""
                                        //   }`}
                                        style={{ padding: '10px', borderRadius: '10px', backgroundColor: '#f3f3f3' }}
                                      >
                                        {" "}
                                        {answer.type === "text" && (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: answer.content,
                                            }}
                                          />
                                        )}
                                        <div className="message-info-td">
                                          <span
                                            class="material-symbols-outlined message-copy"
                                            onClick={() => {
                                              if (answer.content) {
                                                navigator.clipboard.writeText(
                                                  answer.content
                                                );
                                                Alert.success(
                                                  "Message copied successfully"
                                                );
                                              } else {
                                                Alert.error("Message not copy");
                                              }
                                            }}
                                          >
                                            content_copy
                                          </span>
                                        </div>
                                      </li> :
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <li key={idx}
                                          className={`${answer.method === "error" ? "error" : ""
                                            }`}
                                          style={{ padding: '10px', borderRadius: '10px' }}>

                                          {answer.type === "text" && (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: answer.content,
                                              }}
                                            />
                                          )}
                                        </li>
                                      </div>
                                    // ""
                                  ))
                                  : "No message"}
                              </div>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  ))}
              </ul>

             
              <form onSubmit={(e) => saveData(e)}>
                <FormWrapper>
                  <FormGroup className="w-100">
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px", padding: "0px 14px" }}
                    >
                      <FormControl
                        type="text"
                        placeholder={"Type to search"}
                        onChange={
                          (e) => {
                            if (e.target.value === " ") return false;
                            setPrompt(e.target.value);
                          }
                          // this.setState({ prompt: e.target.value })
                        }
                        value={prompt}
                      />
                      <ButtonCommonTheme
                        type="blueModalBtn"
                        btnType="submit"
                        btnStyle="default"
                        className="p-3"
                        size="small"
                        isLoading={props.loadingAssistMsg || loading}
                        disabled={props.loadingAssistMsg || loading}
                        style={{
                          background: "transparent",
                          padding: "8px",
                          border: "2px solid #4860D9",
                        }}
                      >
                        <FaWandMagicSparkles
                          style={{
                            fontSize: "16px",
                            display: "block",
                            color: "rgb(72, 96, 217)",
                          }}
                        />
                      </ButtonCommonTheme>
                    </div>
                  </FormGroup>
                </FormWrapper>
              </form>
            </Tab> */}
            <Tab eventKey="agentAssistant" title="Agent Assist"
            // onClick={() => {
            //   agentAssistHistory();
            // }}
            >
              <div>
                {props.showAgentAssistMsg ? (
                  <div>
                    <div className="suggestionBox agent-chat-container" ref={chatContainerRef}>
                      {/* {props.assistMessages && props.assistMessages.map((msg, i) => (
                        <div key={i}>{msg.message.content.text}</div>
                      ))} */}
                      {props.assistMessages && props.assistMessages.map((data, i) => {
                        const message = data.message;
                        if (!message) {
                          return null;
                        }
                        return (
                          <React.Fragment key={`msg-${message.id || getUUID()}`}>
                            <div
                              className={`message-body-item__main message-body-item__${getRole(
                                message
                              )}`}
                            >
                              <AssistRenderer
                                message={message}
                              />
                            </div>
                          </React.Fragment>
                        )
                      })}
                    </div>
                    {props.typingAssistCus && (
                      <TypingIndicatorBubble name={props.selectedAssignedList.customer.display} />
                    )}
                    <form onSubmit={(e) => sendMessage(e)}>
                      <FormWrapper>
                        <FormGroup className="w-100">
                          <div
                            className="d-flex align-items-center"
                            style={{ gap: "10px", padding: "0px 14px" }}
                          >
                            <FormControl
                              type="text"
                              placeholder={"Type to search"}
                              onChange={handleInputChange}
                              value={props.agentAssistReply || ""}
                            />
                            <ButtonCommonTheme
                              type="blueModalBtn"
                              btnType="submit"
                              btnStyle="default"
                              className="p-3"
                              size="small"
                              isLoading={props.loadingAssistMsg}
                              disabled={props.loadingAssistMsg}
                              style={{
                                background: "transparent",
                                padding: "8px",
                                border: "2px solid #4860D9",
                                color: "rgb(72, 96, 217)",
                              }}
                            >
                              {/* <FaWandMagicSparkles
                                style={{
                                  fontSize: "16px",
                                  display: "block",
                                  color: "rgb(72, 96, 217)",
                                }}
                              /> */}
                              Send
                            </ButtonCommonTheme>
                          </div>
                        </FormGroup>
                      </FormWrapper>
                    </form>

                    {/* <textarea
                      type="text"
                      value={props.agentAssistReply || ""}
                      maxLength={1024}
                      autoFocus={true}
                      onChange={handleInputChange}
                      placeholder="Enter message here..."
                      style={{
                        padding: "6px 20px 0px 20px",
                        marginBottom: "0px",
                      }}
                    />
                    <button onClick={(e) => sendMessage(e)}>Send</button> */}
                  </div>
                ) : (
                  <div className="agent-assist-center">
                    <button className="message-header_right-btn" onClick={startOnClick}>Start new chat</button>
                  </div>
                )}

              </div>

              {/* <textarea
                type="text"
                value={props.agentAssistReply || ""}
                maxLength={1024}
                autoFocus={true}
                onChange={handleInputChange}
                placeholder="Enter message here..."
                style={{
                  padding: "6px 20px 0px 20px",
                  marginBottom: "0px",
                }}
              />
              <div className="d-flex align-items-center gap-3">
                <span
                  class="material-symbols-outlined"
                  onClick={(e) => {
                    e.preventDefault();
                    sendMessage(e, "text");
                  }}
                >
                  send
                </span>
              </div> */}
            </Tab>
          </Tabs>
        </div>
      </TabItemsStyle>
    </div>
  );
};

const stateToProps = (state) => {
  // Fetch the required state properties first
  const selectedAssignedList = chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  );
  const currentUser = globalStateSelector.getDynamic(state, { key: "currentUser" });

  const identifier = `AGENT-ASSIST-SESSION:${currentUser.userId}:${selectedAssignedList.sessionId}`;


  return {
    selectedAssignedList,
    currentUser,
    showCustomerInfo: chatSelector.getChatDynamic(state, "showCustomerInfo"),
    chatAgentAssist: chatSelector.getChatAgentAssist(state),
    loadingAssistMsg: chatSelector.getLoadingAgentAssistStatus(state),
    chatChecklist: chatSelector.getChatDynamic(state,
      `chatChecklist_${selectedAssignedList.sessionId}`
    ) || [],
    agentAssistReply: chatSelector.getChatDynamic(state, `agentAssistReply_${selectedAssignedList.sessionId}`),
    showAgentAssistMsg: chatSelector.getChatDynamic(state, `showAgentAssistMsg_${identifier}`),
    activeTabRight: chatSelector.getActiveTabRight(state),

    assistMessages: chatSelector.getChatDynamic(state, `assistMessageList.${identifier}`) || [],
    typingAssistCus: chatSelector.getAgentTypingStatus(
      state,
      identifier || null
    ),
    assistPaginationInfo: chatSelector.getChatDynamic(state, "assistPaginationInfo"),
  };
};

// const stateToProps = (state) => ({
//   selectedAssignedList: chatSelector.getChatDynamic(
//     state,
//     "selectedAssignedList"
//   ),
//   showCustomerInfo: chatSelector.getChatDynamic(state, "showCustomerInfo"),
//   agentAssist: globalStateSelector.getAgentAssist(state),
//   chatAgentAssist: chatSelector.getChatAgentAssist(state, "chatAgentAssist"),
// });
const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
  setChatAgentAssist: (data, identifier) => {
    dispatch(chatAction.setChatAgentAssist(data, identifier));
  },

  setActiveTabRight: (data) => {
    dispatch(chatAction.setActiveTabRight(data));
  },

  // clearChatAgentAssist: () => dispatch(chatAction.clearChatAgentAssist()),
});
export default connect(stateToProps, dispatchToProps)(ContactRightPartTheme);

// export default ContactRightPartTheme;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ContactRightPartTheme.js